import { FC, PropsWithChildren } from "react";
import { Card as BootstrapCard, CardProps as BootstrapCardProps } from "react-bootstrap";
import styled from "styled-components";
import { TestableOptional } from "../types";

type CardProps = PropsWithChildren<BootstrapCardProps> & TestableOptional;

export const StyledCard = styled(BootstrapCard)`
  &.bg-primary {
    background-color: #ccbce9 !important;
    border-color: #ccbce9 !important;
    color: #4e2d89;
  }
`;

export const Card: FC<CardProps> = ({ children, testId, ...rest }) => {
  return (
    <StyledCard data-testid={`button-${testId}`} {...rest}>
      {children}
    </StyledCard>
  );
};
